/**
 * AnimatedDots - анимированные точки для индикации загрузки/ожидания
 *
 * Использование:
 * <AnimatedDots />                    // Дефолтные точки
 * <AnimatedDots className="custom" /> // С кастомным классом
 */

import { memo } from 'react';
import PropTypes from 'prop-types';
import './AnimatedDots.css';

export const AnimatedDots = memo(({ className = '' }) => {
  const dotsClassName = `animated-dots${className ? ` ${className}` : ''}`;

  return (
    <span className={dotsClassName}>
      <span className="animated-dots__dot">.</span>
      <span className="animated-dots__dot">.</span>
      <span className="animated-dots__dot">.</span>
    </span>
  );
});

AnimatedDots.displayName = 'AnimatedDots';

AnimatedDots.propTypes = {
  className: PropTypes.string,
};
